"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapMatrix = void 0;

var _pipe = require("../pipe/pipe");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _mapMatrix = function _mapMatrix(fn, source) {
  var result = [];

  for (var i = 0; i < source.length; ++i) {
    var row = [];

    for (var j = 0; j < source[i].length; ++j) {
      var value = source[i][j];
      row.push(Array.isArray(fn) ? _pipe.pipe.apply(void 0, _toConsumableArray(fn))(value) : fn(value, i, j, source));
    }

    result.push(row);
  }

  return result;
};
/**
 * Two-Dimensional version of Array.map
 *
 * Takes a function and applies it to all elements of the matrix.
 *
 * @param {Function} fn     Function to be called on all elements
 * @param {[][]}     source Matrix to be iterated over
 *
 * @return {[][]} Returns new instance
 */


var mapMatrix = function mapMatrix() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  /*
   * @signature (fn) => (source: [][]): [][]
   *
   * mapMatrix(x => x + 1)([[1, 2], [3, 4]]) => [[2, 3], [4, 5]]
   */
  if (params.length === 1) {
    return function (source) {
      return _mapMatrix(params[0], source);
    };
  }
  /*
   * @signature (fn, source: [][]): [][]
   *
   * mapMatrix(x => x + 1, [[1, 2], [3, 4]]) => [[2, 3], [4, 5]]
   */


  return _mapMatrix.apply(void 0, params);
};

exports.mapMatrix = mapMatrix;